import type {TurnResponse} from '@wandb/weave/lib/WbAgent/WbAgentClient';

import type {Thread} from '../../agentChat/store/thread';
import {decodePromptForThreadTitle} from './utils';

/**
 * parseTurnTitle extracts a turn's stored title and prompt excerpt as the
 * (title, promptSnippet) pair used by the agent-chat store.
 */
export function parseTurnTitle(
  turn: Pick<TurnResponse, 'title' | 'user_prompt'>
): {title: string | null; promptSnippet: string | null} {
  const stored = turn.title?.trim() ?? '';
  const snippet = decodePromptForThreadTitle(turn.user_prompt ?? '');
  return {
    title: stored || null,
    promptSnippet: snippet || null,
  };
}

/**
 * resolveThreadTitle returns the title to render for a chat history row.
 * Falls back through the stored title, the prompt snippet, and a generic
 * "Untitled conversation" label when both are empty.
 */
export function resolveThreadTitle(thread: Thread): string {
  return (
    thread.title?.trim() || thread.promptSnippet || 'Untitled conversation'
  );
}
